<div class="panneau-ajout-appareil__container">
	<div class="container__content">
        <form [formGroup]="form" (ngSubmit)="handleSubmit($event)">
            <div class="appareil-container">
                <lua-input formControlName="name" label="Nom de l'appareil" [fullWidth]="true"></lua-input>
                <small *ngIf="terminal">ID : {{terminal.terminalId}}</small>
            </div>
            <div class="actions">
                <lua-action-principale libelle="Enregistrer" [isDisabled]="!form.valid" [fullWidth]="false"
                    (click)="handleSubmit($event)"></lua-action-principale>
                <lua-bouton-texte *ngIf="terminal" libelle="Supprimer" color="Error" [fullWidth]="false" [isDisabled]="terminal.isCurrentDevice"
                    (click)="!terminal.isCurrentDevice && handleDelete($event)" startIcon="delete"></lua-bouton-texte>
            </div>
        </form>
    </div>
</div>
